import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router';
import { PublicLayout } from 'hoc';
import { useAudioDevice } from 'providers/AudioDeviceProvider';
import { TestToneProvider } from 'providers/TestToneProvider';
import { DeviceSettingsSection } from 'widgets/audio/DeviceSettingsSection';
import { RecommendedDeviceCard } from 'widgets/audio/RecommendedDeviceCard';
import {
  DevicesCard,
  DevicesCardContent,
  DevicesCardHeader,
  StyledCardTitle,
  Wrapper,
} from './audioSettings.styles';

const STATES_WITHOUT_DEVICE_SETTINGS = new Set(['searching', 'accessBlocked', 'noDevice']);

export default function AudioSettingsScreen() {
  const { t } = useTranslation();
  const audio = useAudioDevice();
  const showDeviceSettings =
    audio.mode === 'active' && !STATES_WITHOUT_DEVICE_SETTINGS.has(audio.state);

  // In the passive mode the route is reachable through the history only.
  if (audio.ready && audio.mode === 'passive') return <Navigate to="/" replace />;

  return (
    <PublicLayout title={t('audio.settings.title')} hasBackButton>
      <Wrapper>
        <DevicesCard>
          <DevicesCardHeader>
            <StyledCardTitle as="h2">{t('audio.settings.devices')}</StyledCardTitle>
          </DevicesCardHeader>
          <DevicesCardContent>
            <TestToneProvider>
              <RecommendedDeviceCard />
              {showDeviceSettings && <DeviceSettingsSection />}
            </TestToneProvider>
          </DevicesCardContent>
        </DevicesCard>
      </Wrapper>
    </PublicLayout>
  );
}
